function get__base_url() {
	var loc = window.location;
	return loc.protocol + "//" + loc.hostname;
};


function is__func(element) {
	return typeof element === 'function';
};


function isset(element) {
	
	let elementIsDeclared = true; 
	try{ element; }
	catch(e) {
		if(e.name == "ReferenceError") {
			elementIsDeclared = false;
		}
	}

	if(elementIsDeclared === false) {
		return false;
	}

	if(typeof element === 'undefined') {
		return false;
	}
	if(element === null) {
		return false;
	}
	if(element === false) {
		return false;
	}
	return true;
};


const convertCamelCase = (string, char) => {
	return string.replace(/[\w]([A-Z])/g, function(m) {
		return m[0] + char + m[1];
	}).toLowerCase();
}

const camelCaseToHyphens = (string) => {
	return convertCamelCase(string,'-');
}

const camelCaseToSnake = (string) => {
	return convertCamelCase(string,'_');
}

const dataAttributeIsTrue = (value) => {

	if(value === '1' || value === 1 || value === 'true' ||  value === true) {
		return true;
	}
	return false;
};


export {
	camelCaseToHyphens,
	camelCaseToSnake,
	dataAttributeIsTrue,
	get__base_url,
	is__func,
	isset
}


